import { useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

export default function AddPartnerDialog({ open, leaders, onClose, onDone }) {
  const [f, setF] = useState({ first_name: "", last_name: "", email: "", nearest_upline_leader_id: "" });
  const [busy, setBusy] = useState(false);
  const ok = f.first_name.trim() && f.last_name.trim() && /\S+@\S+\.\S+/.test(f.email) && f.nearest_upline_leader_id;
  const save = async () => {
    setBusy(true);
    try {
      await api.post("/org/users", f);
      toast.success(`${f.first_name.trim()} ${f.last_name.trim()} added`);
      setF({ first_name: "", last_name: "", email: "", nearest_upline_leader_id: "" });
      onDone();
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not add partner"); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="org-add-dialog">
        <DialogHeader><DialogTitle>Add a partner to your organisation</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div><Label>Preferred first name</Label><Input value={f.first_name} onChange={(e) => setF({ ...f, first_name: e.target.value })} placeholder="e.g. John and Carol" data-testid="org-add-first" /></div>
            <div><Label>Last name</Label><Input value={f.last_name} onChange={(e) => setF({ ...f, last_name: e.target.value })} data-testid="org-add-last" /></div>
          </div>
          <div><Label>Google sign-in email</Label><Input type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="org-add-email" /></div>
          <div><Label>Nearest upline leader</Label>
            <Select value={f.nearest_upline_leader_id} onValueChange={(v) => setF({ ...f, nearest_upline_leader_id: v })}>
              <SelectTrigger className="h-11" data-testid="org-add-upline"><SelectValue placeholder="Choose a leader" /></SelectTrigger>
              <SelectContent>{leaders.map((l) => <SelectItem key={l.id} value={l.id}>{l.name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <p className="text-xs text-slate-500">They're added as a Partner and can sign in with Google using this email.</p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="org-add-cancel">Cancel</Button>
          <Button onClick={save} disabled={!ok || busy} className="bg-[#0A1F44] text-white" data-testid="org-add-save">Add partner</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
